import { connect } from "react-redux";

import { getAuthToken, getExpired } from "../../store/selectors/appConfig";
import { getUploadDocuments } from "../../store/selectors/uploadDocuments";
import { checkLoginStatus, getAgentId } from "../../store/selectors/loginSelector";
import { sessionLogout } from "../../store/actions/loginForm";
import { setAccessToken } from "../../store/actions/appConfig";
import { SessionExpiration } from "./SessionExpiration";
import { getCompletedSteps } from "../../store/selectors/completedSteps";

const mapStateToProps = state => ({
  expired: getExpired(state),
  authToken: getAuthToken(state),
  isAuthenticated: checkLoginStatus(state),
  uploadDocuments: getUploadDocuments(state),
  completedSteps: getCompletedSteps(state),
  agentId: getAgentId(state)
});

const mapDispatchToProps = {
  logout: sessionLogout,
  setAccessToken
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(SessionExpiration);
